var open = false;

var styles = {
  fontSize: '1rem',
  grayScale: false,
  highContrast: false,
  negativeContrast: false,
  lightBackground: false,
  underlineLinks: false,
  altFonts: false
};

function openHelper() {
  $(".accessibility-helper").addClass("open");
}

function closeHelper() {
  $(".accessibility-helper").removeClass("open");
}

function toggleHelper() {
  if ($(".accessibility-helper").hasClass("open")) {
    closeHelper();
  } else {
    openHelper();
  }
}

function applyChanges() {
  $("html")[0].style.fontSize = styles.fontSize;

  if (styles.grayScale) {
    $("html").addClass("gray-scale");
  } else {
    $("html").removeClass("gray-scale");
  }

  if (styles.highContrast) {
    $("body").addClass("high-contrast");
  } else {
    $("body").removeClass("high-contrast");
  }

  if (styles.negativeContrast) {
    $("body").addClass("negative-contrast");
  } else {
    $("body").removeClass("negative-contrast");
  }

  if (styles.lightBackground) {
    $("body").addClass("light-background");
  } else {
    $("body").removeClass("light-background");
  }

  if (styles.underlineLinks) {
    $("body").addClass("underlined-links");
  } else {
    $("body").removeClass("underlined-links");
  }

  if (styles.altFonts) {
    $("body").addClass("alt-fonts");
  } else {
    $("body").removeClass("alt-fonts");
  }
}

function fontSize(value) {
  if (value > 0) {
    if (parseFloat(styles.fontSize) < 2) {
      styles.fontSize = parseFloat(styles.fontSize) + value + 'rem'
    }
  } else {
    if (parseFloat(styles.fontSize) > 1) {
      styles.fontSize = parseFloat(styles.fontSize) + value + 'rem'
    }
  }

  applyChanges();
}

function toggleGrayScale() {
  styles.highContrast = false
  styles.negativeContrast = false
  styles.lightBackground = false
  styles.grayScale = !styles.grayScale

  applyChanges();
}

function toggleHighContrast() {
  styles.grayScale = false
  styles.negativeContrast = false
  styles.lightBackground = false
  styles.highContrast = !styles.highContrast

  applyChanges();
}

function toggleNegativeContrast() {
  styles.grayScale = false
  styles.highContrast = false
  styles.lightBackground = false
  styles.negativeContrast = !styles.negativeContrast

  applyChanges();
}

function toggleLightBackground() {
  styles.grayScale = false
  styles.highContrast = false
  styles.negativeContrast = false
  styles.lightBackground = !styles.lightBackground

  applyChanges();
}

function toggleUnderlineLinks() {
  styles.underlineLinks = !styles.underlineLinks

  applyChanges();
}

function toggleAltFonts() {
  styles.altFonts = !styles.altFonts

  applyChanges();
}

function resetStyles() {
  styles = {
    fontSize: '1rem',
    grayScale: false,
    highContrast: false,
    negative: false,
    lightBackground: false,
    underlineLinks: false,
    altFonts: false
  }

  applyChanges();
}

$(document).ready(function () {
  $("#accessibility-btn").click(function () {
    toggleHelper();
  });

  $("[data-ah-font-size]").click(function () {
    var value = $(this).data('ah-font-size');
    fontSize(value);
  });

  $("[data-ah-toggle-gray-scale]").click(function () {
    toggleGrayScale();
  });

  $("[data-ah-toggle-high-contrast]").click(function () {
    toggleHighContrast();
  });

  $("[data-ah-toggle-negative-contrast]").click(function () {
    toggleNegativeContrast();
  });

  $("[data-ah-toggle-light-background]").click(function () {
    toggleLightBackground();
  });

  $("[data-ah-toggle-underline-links]").click(function () {
    toggleUnderlineLinks();
  });

  $("[data-ah-toggle-alt-fonts]").click(function () {
    toggleAltFonts();
  });

  $("[data-ah-reset]").click(function () {
    resetStyles();
  });
});